import { generatePath } from "react-router-dom";
import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const getFeatureFlags = async () => {
  const res = await axios.get(apiRoutes.FEATURE_FLAGS);
  return res.data;
};

export const getAdminFeatureFlags = async () => {
  const res = await axios.get(apiRoutes.ADMIN_FEATURE_FLAGS);
  return res.data;
};

export const createFeatureFlag = async ({ key, description, enabled }) => {
  const res = await axios.post(apiRoutes.ADMIN_FEATURE_FLAGS, {
    key,
    description,
    enabled,
  });
  return res.data;
};

export const updateFeatureFlag = async (key, { enabled, description }) => {
  const res = await axios.patch(
    generatePath(apiRoutes.ADMIN_FEATURE_FLAG, { key }),
    { enabled, description },
  );
  return res.data;
};

export const deleteFeatureFlag = async (key) => {
  const res = await axios.delete(
    generatePath(apiRoutes.ADMIN_FEATURE_FLAG, { key }),
  );
  return res.data;
};
